import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetcBCAPendingNotifications,
  fetchAvailableTrainers,
  fetchLiveBCAStats,
  fetchLivePTTrialStats,
  fetchLiveSubsLogs,
  fetchLiveSubsStats,
  fetchRenewalCheckin,
  fetchRenewalCheckinStat,
  fetchRenewalsStat,
  fetcMemberCheckinsLog,
  fetcMemberCheckinStats,
  fetcPTTrialNotifications,
} from "./liveApiS";

export const fetchLiveSubsStatsData = createAsyncThunk(
  "api/fetchLiveSubsStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLiveSubsStats(filters, token);
    return response;
  }
);

export const fetchLiveSubsLogsData = createAsyncThunk(
  "api/fetchLiveSubsLogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLiveSubsLogs(filters, token);
    return response;
  }
);

export const fetcBCAPendingNotificationsData = createAsyncThunk(
  "api/fetcBCAPendingNotificationsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetcBCAPendingNotifications(filters, token);
    return response;
  }
);

export const fetcPTTrialNotificationsData = createAsyncThunk(
  "api/fetcPTTrialNotificationsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetcPTTrialNotifications(filters, token);
    return response;
  }
);

export const fetcMemberCheckinsLogData = createAsyncThunk(
  "api/fetcMemberCheckinsLogData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetcMemberCheckinsLog(filters, token);
    return response;
  }
);

export const fetcMemberCheckinStatsData = createAsyncThunk(
  "api/fetcMemberCheckinStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetcMemberCheckinStats(filters, token);
    return response;
  }
);

export const fetchAvailableTrainersData = createAsyncThunk(
  "api/fetchAvailableTrainersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAvailableTrainers(filters, token);
    return response;
  }
);

export const fetchRenewalCheckinStatData = createAsyncThunk(
  "api/fetchRenewalCheckinStatData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRenewalCheckinStat(filters, token);
    return response;
  }
);

export const fetchRenewalCheckinData = createAsyncThunk(
  "api/fetchRenewalCheckinData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRenewalCheckin(filters, token);
    return response;
  }
);

export const fetchLivePTTrialStatsData = createAsyncThunk(
  "api/fetchLivePTTrialStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLivePTTrialStats(filters, token);
    return response;
  }
);

export const fetchLiveBCAStatsData = createAsyncThunk(
  "api/fetchLiveBCAStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLiveBCAStats(filters, token);
    return response;
  }
);

const liveSlice = createSlice({
  name: "live",
  initialState: {
    liveSubsStats: null,
    liveSubsStatsError: null,
    liveSubsStatsLoading: false,

    liveSubsLogs: null,
    liveSubsLogsError: null,
    liveSubsLogsLoading: false,

    bcaPendingNotifications: null,
    bcaPendingNotificationsError: null,
    bcaPendingNotificationsLoading: false,

    ptTrialNotifications: null,
    ptTrialNotificationsError: null,
    ptTrialNotificationsLoading: false,

    memberCheckinsLog: null,
    memberCheckinsLogError: null,
    memberCheckinsLogLoading: false,

    memberCheckinStats: null,
    memberCheckinStatsError: null,
    memberCheckinStatsLoading: false,

    availableTrainers: null,
    availableTrainersError: null,
    availableTrainersLoading: false,

    renewalCheckinStat: null,
    renewalCheckinStatError: null,
    renewalCheckinStatLoading: false,

    renewalCheckin: null,
    renewalCheckinError: null,
    renewalCheckinLoading: false,

    liveResolutionStats: null,
    liveResolutionStatsError: null,
    liveResolutionStatsLoading: false,

    liveBCAResolutionStats: null,
    liveBCAResolutionStatsError: null,
    liveBCAResolutionStatsLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLiveSubsStatsData.pending, (state) => {
        state.liveSubsStatsLoading = true;
        state.liveSubsStatsError = null;
      })
      .addCase(fetchLiveSubsStatsData.fulfilled, (state, action) => {
        state.liveSubsStatsLoading = false;
        state.liveSubsStatsError = null;
        state.liveSubsStats = action.payload;
      })
      .addCase(fetchLiveSubsStatsData.rejected, (state, action) => {
        state.liveSubsStatsLoading = false;
        state.liveSubsStatsError = action.error.message;
      })

      .addCase(fetchLiveSubsLogsData.pending, (state) => {
        state.liveSubsLogsLoading = true;
        state.liveSubsLogsError = null;
      })
      .addCase(fetchLiveSubsLogsData.fulfilled, (state, action) => {
        state.liveSubsLogsLoading = false;
        state.liveSubsLogsError = null;
        state.liveSubsLogs = action.payload;
      })
      .addCase(fetchLiveSubsLogsData.rejected, (state, action) => {
        state.liveSubsLogsLoading = false;
        state.liveSubsLogsError = action.error.message;
      })

      .addCase(fetcBCAPendingNotificationsData.pending, (state) => {
        state.bcaPendingNotificationsLoading = true;
        state.bcaPendingNotificationsError = null;
      })
      .addCase(fetcBCAPendingNotificationsData.fulfilled, (state, action) => {
        state.bcaPendingNotificationsLoading = false;
        state.bcaPendingNotificationsError = null;
        state.bcaPendingNotifications = action.payload;
      })
      .addCase(fetcBCAPendingNotificationsData.rejected, (state, action) => {
        state.bcaPendingNotificationsLoading = false;
        state.bcaPendingNotificationsError = action.error.message;
      })

      .addCase(fetcPTTrialNotificationsData.pending, (state) => {
        state.ptTrialNotificationsLoading = true;
        state.ptTrialNotificationsError = null;
      })
      .addCase(fetcPTTrialNotificationsData.fulfilled, (state, action) => {
        state.ptTrialNotificationsLoading = false;
        state.ptTrialNotificationsError = null;
        state.ptTrialNotifications = action.payload;
      })
      .addCase(fetcPTTrialNotificationsData.rejected, (state, action) => {
        state.ptTrialNotificationsLoading = false;
        state.ptTrialNotificationsError = action.error.message;
      })

      .addCase(fetcMemberCheckinsLogData.pending, (state) => {
        state.memberCheckinsLogLoading = true;
        state.memberCheckinsLogError = null;
      })
      .addCase(fetcMemberCheckinsLogData.fulfilled, (state, action) => {
        state.memberCheckinsLogLoading = false;
        state.memberCheckinsLogError = null;
        state.memberCheckinsLog = action.payload;
      })
      .addCase(fetcMemberCheckinsLogData.rejected, (state, action) => {
        state.memberCheckinsLogLoading = false;
        state.memberCheckinsLogError = action.error.message;
      })

      .addCase(fetcMemberCheckinStatsData.pending, (state) => {
        state.memberCheckinStatsLoading = true;
        state.memberCheckinStatsError = null;
      })
      .addCase(fetcMemberCheckinStatsData.fulfilled, (state, action) => {
        state.memberCheckinStatsLoading = false;
        state.memberCheckinStatsError = null;
        state.memberCheckinStats = action.payload;
      })
      .addCase(fetcMemberCheckinStatsData.rejected, (state, action) => {
        state.memberCheckinStatsLoading = false;
        state.memberCheckinStatsError = action.error.message;
      })

      .addCase(fetchAvailableTrainersData.pending, (state) => {
        state.availableTrainersLoading = true;
        state.availableTrainersError = null;
      })
      .addCase(fetchAvailableTrainersData.fulfilled, (state, action) => {
        state.availableTrainersLoading = false;
        state.availableTrainersError = null;
        state.availableTrainers = action.payload;
      })
      .addCase(fetchAvailableTrainersData.rejected, (state, action) => {
        state.availableTrainersLoading = false;
        state.availableTrainersError = action.error.message;
      })

      .addCase(fetchRenewalCheckinStatData.pending, (state) => {
        state.renewalCheckinStatLoading = true;
        state.renewalCheckinStatError = null;
      })
      .addCase(fetchRenewalCheckinStatData.fulfilled, (state, action) => {
        state.renewalCheckinStatLoading = false;
        state.renewalCheckinStatError = null;
        state.renewalCheckinStat = action.payload;
      })
      .addCase(fetchRenewalCheckinStatData.rejected, (state, action) => {
        state.renewalCheckinStatLoading = false;
        state.renewalCheckinStatError = action.error.message;
      })

      .addCase(fetchRenewalCheckinData.pending, (state) => {
        state.renewalCheckinLoading = true;
        state.renewalCheckinError = null;
      })
      .addCase(fetchRenewalCheckinData.fulfilled, (state, action) => {
        state.renewalCheckinLoading = false;
        state.renewalCheckinError = null;
        state.renewalCheckin = action.payload;
      })
      .addCase(fetchRenewalCheckinData.rejected, (state, action) => {
        state.renewalCheckinLoading = false;
        state.renewalCheckinError = action.error.message;
      })

      .addCase(fetchLivePTTrialStatsData.pending, (state) => {
        state.liveResolutionStatsLoading = true;
        state.liveResolutionStatsError = null;
      })
      .addCase(fetchLivePTTrialStatsData.fulfilled, (state, action) => {
        state.liveResolutionStatsLoading = false;
        state.liveResolutionStatsError = null;
        state.liveResolutionStats = action.payload;
      })
      .addCase(fetchLivePTTrialStatsData.rejected, (state, action) => {
        state.liveResolutionStatsLoading = false;
        state.liveResolutionStatsError = action.error.message;
      })

      .addCase(fetchLiveBCAStatsData.pending, (state) => {
        state.liveBCAResolutionStatsLoading = true;
        state.liveBCAResolutionStatsError = null;
      })
      .addCase(fetchLiveBCAStatsData.fulfilled, (state, action) => {
        state.liveBCAResolutionStatsLoading = false;
        state.liveBCAResolutionStatsError = null;
        state.liveBCAResolutionStats = action.payload;
      })
      .addCase(fetchLiveBCAStatsData.rejected, (state, action) => {
        state.liveBCAResolutionStatsLoading = false;
        state.liveBCAResolutionStatsError = action.error.message;
      });
  },
});

export default liveSlice.reducer;
